import { LegalTextStack } from '@collab/atoms';
import ContentWrapper from '@collab/atoms/ContentWrapper';

import { CookieRow, CookieSection } from './Components';
import Introduction from './Introduction';
import content from './cookie.content';
import data from './cookie.data';

export type CookieTemplateProps = {
  cookies?: {
    strictlyNecessary?: CookieRow[];
    functional?: CookieRow[];
    statistics?: CookieRow[];
  };
};

const CookieTemplate: React.FC<CookieTemplateProps> = ({ cookies }) => {
  const strictlyNecessaryCookies = [
    ...data.strictlyNecessary,
    ...(cookies?.strictlyNecessary ? cookies.strictlyNecessary : []),
  ];
  const statisticsCookies = [
    ...data.statistics,
    ...(cookies?.statistics ? cookies.statistics : []),
  ];
  const functionalCookies = [
    ...data.functional,
    ...(cookies?.functional ? cookies.functional : []),
  ];

  return (
    <ContentWrapper>
      <LegalTextStack>
        <Introduction />
        <h2>{content.strictlyNecessary.title}</h2>
        <p>{content.strictlyNecessary.text}</p>
        <CookieSection data={strictlyNecessaryCookies} />
        {cookies?.functional && (
          <>
            <h2>{content.functional.title}</h2>
            <p>{content.functional.text}</p>
            <CookieSection data={functionalCookies} />
          </>
        )}
        <h2>{content.statistics.title}</h2>
        <p>{content.statistics.text}</p>
        <CookieSection data={statisticsCookies} />
      </LegalTextStack>
    </ContentWrapper>
  );
};

export default CookieTemplate;
